export function createSortConfiguration(property, order = 'DESC') {
  return [...(property ? [{
    property,
    order: order,
    missing: '_last'
  }] : []), {
    property: 'hs_object_id',
    order: 'DESC',
    missing: '_last'
  }];
}